<template>
  <div>
    <div v-if="loading">
      <wait-spinner />
    </div>
    <div v-else>
      <passing-sequence />
      <scorer-table v-if="gameType === 'stakes'" />
      <scorer-table-mimir v-if="gameType === 'mimir'" />
      <button-container v-if="!buttonContainerCompactFlag || gameType === 'stakes'" />
      <button-container-compact v-else />
      <game-over-result v-if="finishGame && !resumeGame" />
      <display-question v-if="!resumeGame" ref="DisplayQuestion" />
      <resume-game-notice v-if="resumeGame" />
      <randomise-players v-if="questionDisplayMode === 'Start' && !b612Friendly && !resumeGame"
        ref="RandomisePlayers" />
      <randomise-players-new v-if="questionDisplayMode === 'Start' && b612Friendly && !resumeGame"
        ref="RandomisePlayers" />
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

import ScorerTable from "../components/ScorerTableNew.vue";
import ScorerTableMimir from "../components/ScorerTableMimir.vue";
import PassingSequence from "../components/PassingSequence.vue";
import ButtonContainer from "../components/ButtonContainer.vue";
import ButtonContainerCompact from "../components/ButtonContainerCompact.vue";
import GameOverResult from "../components/GameOverResult.vue";
import DisplayQuestion from "../components/DisplayQuestion.vue";
import RandomisePlayers from "../components/RandomisePlayers.vue";
import RandomisePlayersNew from "../components/RandomisePlayersNew.vue";
import WaitSpinner from "../components/WaitSpinner.vue";
import ResumeGameNotice from "../components/ResumeGameNotice.vue";

export default {
  components: {
    ScorerTable,
    ScorerTableMimir,
    PassingSequence,
    ButtonContainer,
    ButtonContainerCompact,
    GameOverResult,
    DisplayQuestion,
    RandomisePlayers,
    RandomisePlayersNew,
    WaitSpinner,
    ResumeGameNotice,
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    ...mapState([
      "finishGame",
      "questionDisplayMode",
      "gameType",
      "b612Friendly",
      "objectId",
      "resumeGame",
      "finishGame",
      "gameType",
      "gameId",
      "buttonContainerCompactFlag"
    ]),
  },
  methods: {
    ...mapActions([
      "fetchGameData",
      "switchQuestionMode",
      "toggleResumeGame",
      "setGameType",
    ]),
  },
  mounted() {
    if (!this.objectId) {
      this.loading = true;
      this.toggleResumeGame();
      this.fetchGameData(this.$route.params.gameId).then(() => {
        this.setGameType(this.$route.params.gameType);
        if (this.finishGame) {
          this.$router.push(`/result/${this.gameType}/${this.gameId}`);
        }
        this.loading = false;
      });
    }
  },
};
</script>

<style></style>